<!--
 *  大搜
 * @FilePath: packages/vue-m-comprehensive/src/views/SearchModule/index.vue
-->
<template>
  <div class="search-polymerization">
    <!-- 搜索框 -->
    <SearchInput
      placeholder="输入疾病/药品/症状/医生/检查"
      :value.sync="searchValue"
      :is-focus="true"
      @keypress="handleSubmit"
    />
    <!-- 联想词 -->
    <AutomatedKeyword
      v-if="keywordList.length > 0"
      :keyword-list="keywordList"
      @clickItem="handleKeyWord"
    />
    <!-- 历史搜索 -->
    <SearchHistory
      v-else
      :history-list="historyList"
      @clear="clearHistory"
      @clickItem="clickItem"
    />
    <!-- pop -->
    <cube-popup ref="popup" type="my-popup" :mask="false">{{
      popup.popupText
    }}</cube-popup>
  </div>
</template>

<script>
import { newSuggestion } from '@/services/index';
import SearchInput from '@@/components-business-m/src/search-input/index.vue';
import * as cyDetect from '@cy/detect';
import SearchHistory from './components/SearchHistory.vue';
import AutomatedKeyword from './components/AutomatedKeyword.vue';

const wx = require('weixin-js-sdk');

export default {
  components: {
    SearchInput,
    SearchHistory,
    AutomatedKeyword,
  },
  data() {
    return {
      // 历史搜索
      historyList: [],
      // 联想词列表
      keywordList: [],
      // 搜索信息
      searchValue: '',
      // pop内容
      popup: {
        popupText: '',
        visible: true,
      },
      // 打点来源
      fromType: this.$route.query.from_type,
    };
  },
  watch: {
    searchValue(data, old) {
      if (data) {
        if (data !== old) {
          this.getNewSuggestion();
        }
      } else {
        this.keywordList = [];
      }
    },
  },
  created() {
    this.getHistoryList();
  },
  methods: {
    /**
     *  从本地存储拿historyList
     */
    getHistoryList() {
      try {
        const historyList = window.localStorage.getItem('__SEARCH_HISTORY__');
        if (historyList) {
          this.historyList = JSON.parse(historyList);
        }
      } catch (err) {
        console.log('不支持localstorage');
      }
    },
    /**
     *  提交表单
     */
    handleSubmit() {
      // todo 完善form_type
      if (this.replaceHistoryList()) {
        if (cyDetect.isFromCY()) {
          window.location.href = `/api/v8/home_search/?from_type=shouye&query=${this.searchValue}#OPEN_NEW_WIN`;
          return;
        }
        if (cyDetect.isFromWechat()) {
          try {
            wx.miniProgram.getEnv(wxres => {
              if (wxres.miniprogram) {
                wx.miniProgram.navigateTo({
                  url: `/pages/home_search/index?query=${this.searchValue}`,
                });
              }
            });
          } catch (err) {
            console.log(err);
          }
          return;
        }
        window.location.href = `/api/v8/home_search/?from_type=${this.fromType}&query=${this.searchValue}#OPEN_NEW_WIN`;
      }
    },
    /**
     *  清除历史搜索记录
     */
    clearHistory() {
      this.historyList = [];
      window.localStorage.removeItem('__SEARCH_HISTORY__');
    },
    /**
     *  更新历史搜索记录
     */

    replaceHistoryList() {
      const regu = '^[ ]+$';
      const re = new RegExp(regu);
      re.test(this.searchValue);
      if (!this.searchValue || re.test(this.searchValue)) {
        this.popup.popupText = '搜索框内容不能为空';
        this.$refs.popup.show();
        const timer = setTimeout(() => {
          if (this.$refs.popup) {
            this.$refs.popup.hide();
          }
          clearTimeout(timer);
        }, 1500);
        return false;
      }
      const findIndex = this.historyList.indexOf(this.searchValue);
      if (findIndex > -1) {
        this.historyList.splice(findIndex, 1);
      }
      this.historyList.unshift(this.searchValue);
      if (this.historyList.length > 15) {
        this.historyList.splice(15, this.historyList.length - 15);
      }
      window.localStorage.setItem(
        '__SEARCH_HISTORY__',
        JSON.stringify(this.historyList)
      );
      return true;
    },
    /**
     * 点击历史词条
     *
     * @param {string} val 词条内容
     */
    clickItem(val) {
      this.searchValue = val;
      if (this.replaceHistoryList()) {
        this.handleSubmit();
      }
    },
    /**
     * 点击联想词条
     *
     * @param {string} val 词条内容
     */
    handleKeyWord(val) {
      this.searchValue = val;
      if (this.replaceHistoryList()) {
        this.handleSubmit();
      }
    },
    /**
     * 大搜联想词
     */
    getNewSuggestion() {
      const params = {
        query: this.searchValue,
        type: 'big_search',
      };
      newSuggestion(params)
        .then(res => {
          const { error_no, error_msg, data } = res;
          if (error_no === 0) {
            this.keywordList = data;
          } else {
            this.$createToast({
              time: 1000,
              txt: error_msg || `获取联想词列表失败`,
              type: 'txt',
            }).show();
          }
        })
        .catch(() => {
          this.$createToast({
            time: 1000,
            txt: `获取联想词列表失败`,
            type: 'txt',
          }).show();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.search-polymerization {
  padding-top: rem(54);
}
</style>
